module.exports = __webpack_public_path__ + "media/images/icon_bgc_gray-62f1da99886a586535472a88aa7fd3f8.png";